import type { PhotoAngle } from '../lib/types'

export function PoseGuide({ angle }: { angle: PhotoAngle }) {
  return (
    <svg
      viewBox="0 0 130 190"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className="h-full w-full"
    >
      {angle === 'detail' ? (
        <>
          <path d="M22 68V46a14 14 0 0 1 14-14h20" />
          <path d="M108 68V46a14 14 0 0 0-14-14H74" />
          <path d="M22 124v22a14 14 0 0 0 14 14h20" />
          <path d="M108 124v22a14 14 0 0 1-14 14H74" />
          <path d="M65 84v22M54 95h22" strokeDasharray="3 6" />
        </>
      ) : (
        <>
          <ellipse cx="65" cy="90" rx="53" ry="70" />
          <path d="M24 84h82" strokeDasharray="4 7" />
          <path d="M65 160v18" strokeDasharray="4 7" />
        </>
      )}
    </svg>
  )
}
